import React from 'react'
import {HiOutlineChevronDoubleUp} from 'react-icons/hi'

const Contacts = () => {
  return (
    <div id = 'contact' className = "w-full lg:h-screen ">
      <div className = "max-w-[1240px] m-auto px-2 py-16 w-full">
          <div className = "flex justify-center items-center flex-col">
            <p className = "text-4xl tracking-widest text-[#5651e5]">CONTACT</p>
            {/* <p className = " text-2xl py-4">Get In Touch</p> */}
          </div>
          <div className = "flex justify-center items-center w-full">
            <div className = "w-[50%]">
            <div className = "col-span-3 w-full h-auto shadow-xl shadow-gray-400 rounded-xl lg:p-4">
                <div className = "lg:p-4 h-full ">
                    <form >
                        <div className = "grid md:grid-cols-2 gap-4 w-full py-2 px-2">
                            <div className = "flex flex-col ">
                                <label className = "uppercase text-md py-2">Name</label>
                                <input className = "border-2 rounded-lg p-3 flex border-gray-300" type="text" />

                            </div>
                            <div className = "flex flex-col ">
                                <label className = "uppercase text-md py-2">Phone Number</label>
                                <input className = "border-2 rounded-lg p-3 flex border-gray-300" type="number" />
                            </div>
                        </div>
                        <div className = "flex flex-col py-2 px-2">
                            <label className = "uppercase text-md py-2">E-Mail</label>
                            <input className = "border-2 rounded-lg p-3 flex border-gray-300" type="email" />
                        </div>
                        <div className = "flex flex-col py-2 px-2">
                            <label className = "uppercase text-md py-2">Subject</label>
                            <input className = "border-2 rounded-lg p-3 flex border-gray-300" type="text" />
                        </div>
                        <div className = "flex flex-col py-2 px-2">
                            <label className = "uppercase text-md py-2">Message</label>
                            <textarea className = "border-2 rounded-lg p-3 border-gray-300" rows = "3"  />
                        </div>
                        <div className = "flex justify-center items-center">
                        <button className = "uppercase p-4 w-[93%] text-gray-100 mt-4 mb-4 hover:scale-105 duration-500">Send Message</button>
                        </div>
                        
                    </form>
                </div>
            </div>
            </div>
          </div>
        <div className = "flex justify-center py-12">
            <a href="#home">
                <div className = "rounded-full shadow-lg shadow-gray-400 p-4 cursor-pointer hover:scale-105 ease-in duration-300">
                    <HiOutlineChevronDoubleUp className = "m-auto text-[#5651e5]" size = {30} />
                </div>
            </a>
        </div>
      </div>
    </div>
  )
}

export default Contacts
